import { useId } from "react";

export default function FilterIcon() {
  const id = useId();
  const gradId = `grad-${id}`;
  const clipId = `clip-${id}`;

  return (
    <svg
      className="icon-size"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          className="icon-svg"
          fill={`url(#${gradId})`}
          d="M21.2858 2.71423H2.71436C2.71514 4.80504 3.42045 6.83458 4.71642 8.47529C6.0124 10.116 7.82343 11.2721 9.85721 11.7571V21.2857L14.1429 18.4285V11.7571C16.1767 11.2721 17.9877 10.116 19.2837 8.47529C20.5797 6.83458 21.285 4.80504 21.2858 2.71423Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_9075_142429">
          <rect width="20" height="20" fill="white" transform="translate(2 2)" />
        </clipPath>
      </defs>
    </svg>
  );
}
